module.exports = __webpack_public_path__ + "media/images/profile-f0231f0bd28be7037cfd9a7fa342abe7.png";